import Header from '../../../../components/Header';
import Podcasts from '../PodcastRegistration/components/Podcasts';

import { Container, Content } from './styles';

export const EditPodcasts = () => {
  return (
    <Container>
      <Header />
      <Content>
        <h1>Editar Podcast</h1>
        <Podcasts />
      </Content>
    </Container>
  );
};

export default EditPodcasts;
